import React from "react";
import InputComponent from "../../../../componennts/input";

function SocialMedia_Section() {

    const data = [
        { id: 1, name: 'VK', url: 'vk.com/', note: '*' },
        { id: 2, name: 'OK', url: 'ok.ru/', note: '*' },
        { id: 3, name: 'Instagram', url: 'instagram.com/', note: '*' },
        { id: 4, name: 'FB', url: 'facebook.com/', note: '*' },
        { id: 5, name: 'TikTok', url: 'tiktok.com/', note: '*' },
        { id: 6, name: 'Threads', url: 'threads.com/', note: '*' },
    ];

    return <div id={'social_media_section'} className={''}>

        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
            <thead>
            <tr style={{ backgroundColor: '#f4f4f4', textAlign: 'left' }}>
                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Соціальна мережа</th>
                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Посилання</th>
                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Інформація на соціальній мережі</th>
            </tr>
            </thead>
            <tbody>
            {data.map((social) => (
                <tr key={social.id}>
                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        {social.name}
                    </td>
                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        <InputComponent
                            id={'id'}
                            type={'text'}
                            name={social.name}
                            // value={props.value.note}
                            // onChange={(e) => props.onChange(props.id, e, field.field)}
                            placeholder={social.url}
                            class={'form-control rounded-0 border-0 border-bottom '}
                        />
                    </td>
                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                        <InputComponent
                            id={'id'}
                            type={'text'}
                            name={social.name}
                            // value={props.value.note}
                            // onChange={(e) => props.onChange(props.id, e, field.field)}
                            placeholder={social.note}
                            class={'form-control rounded-0 border-0 border-bottom '}
                        />
                    </td>
                </tr>
            ))}
            </tbody>
        </table>

        <div className={'border p-1'}>
            <b>Інтереси в ТГ:</b>
            <p>
                <i>
                    Аналіз інтересів, перелік груп, в яких перебуває/перебував, повідомлення в групах у вигляді додатків.
                </i>
            </p>
            <textarea name="" id="" cols="60" rows="5" className={'w-100 form-control'} placeholder={'Не виявлено'} />
        </div>

        <div className={'border p-1'}>
            <b>Висновок з Артеліанс (ШІ) на основі активності в соціальних мережах (доцільно відпрацьовувати у вигляді додатку):</b>
            <p>
                <i>
                    Інформація про активність - групи, повідомлення, коментарі, інтереси, хобі, захоплення.
                </i>
            </p>
            <textarea name="" id="" cols="60" rows="5" className={'w-100 form-control'} placeholder={'Не виявлено'} />
        </div>

    </div>
}

export default SocialMedia_Section;
